var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.release)?_c('div',{staticClass:"release-details height-all"},[(_vm.isMonthlyRelease)?_c('MonthlyReleaseDetails',{attrs:{"release":_vm.release}}):_c('BookReleaseDetails',{attrs:{"release":_vm.release}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }